/**
 * 提示词结构模板配置
 * 统一导出3个步骤模板
 */
import step1Template from './step1Template';
import step2Template from './step2Template';
import step3Template from './step3Template';

export default [
  step1Template,
  step2Template,
  step3Template
];

